interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
}

export function EmptyState({ icon, title, description }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      {icon ? (
        <div className="text-text-muted mb-4 [&>svg]:h-12 [&>svg]:w-12">{icon}</div>
      ) : null}
      <h3 className="text-lg font-medium text-text-primary">{title}</h3>
      {description ? (
        <p className="text-sm text-text-secondary mt-1 text-center max-w-sm">{description}</p>
      ) : null}
    </div>
  );
}

export default EmptyState;
